import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import '@/utils/AlimamaShuHeiTi-Bold-normal.js';
export function phyToPDF(activeType, bedName, date) {
  return new Promise((resolve, reject) => { 
    setTimeout(async () => {
      try {
        const contentContainer = document.getElementById('reportExportPdf');
        if (!contentContainer) return;

        let pdfConfig = {
          format: 'a4', // 纸张格式
          margin: 12, // 页面边距（单位：mm）
          scale: 2, // html2canvas 缩放比例（提高清晰度）
        }
        // 1. 初始化 jsPDF 实例
        const doc = new jsPDF({
          orientation: 'portrait', // 纵向
          unit: 'mm',
          format: pdfConfig.format,
        });

        /**
         * 导入字体包，pdfjs 不支持中文识别，需要加入中文字体包才不乱码
         * 
         * 生成字体包流程
         *  1. 找相对应的.ttf文件并下载下来，目前使用 AlimamaShuHeiTi-Bold-normal.ttf
         *  2. 打开 assets/pfdztb 文件夹下的 fontconverter.html
         *  3. fontStyle 下拉选择 normal、Module format下拉选项选择 UMD、File 为第一步下载的.ttf文件
         *  4. 最后点击 create 生成 pdf 兼容中的 js 库，将js库保存到项目中并引入（如目前引用的是/utils/AlimamaShuHeiTi-Bold-normal.js文件）
         *  5. 点击项目中的 js 文件 并按以下代码对比进行引入
         */
        doc.addFont('AlimamaShuHeiTi-Bold-normal.ttf', 'AlimamaShuHeiTi-Bold', 'normal'); // 字体名称是 MyFont
        doc.setFont('AlimamaShuHeiTi-Bold');

        // 2. 计算 PDF 页面的可用尺寸（转换为 px，1mm ≈ 3.78px）
        const pageWidthMm = doc.internal.pageSize.getWidth() - 2 * pdfConfig.margin;
        const pageHeightMm = doc.internal.pageSize.getHeight() - 2 * pdfConfig.margin;
        const pageWidthPx = pageWidthMm * 3.78;
        // 界面元素 px 为A4纸的3.78倍，但是高按3.78留白太大，目前定义高为4倍，后边如有截断或显示不全，需将高调至 3.78
        const pageHeightPx = pageHeightMm * 3.85;

        // 3. 获取 ECharts 渲染的 Canvas 元素，并将dom节点中的 Canvas 转为图片
        const canvasArs = contentContainer.querySelectorAll('canvas');
        for(let i = 0; i < canvasArs.length; i++) {
          const canvas = canvasArs[i];
          if (canvas) {
            const imgData = canvas.toDataURL('image/png');
            const img = new Image();
            img.src = imgData;
            img.style.width = '100%'; // 确保图片宽度与容器一致
            img.style.height = 'auto';
            const parentNode = canvas.parentNode;
            // 用 <img> 元素替换掉原来的 <canvas> 元素
            parentNode.replaceChild(img, canvas);
          }
        }

        let items = [];
        if(activeType == 1) {
          // 针对睡眠指标添加边框
          const smzbDom = contentContainer.querySelector('.leCont');
          if(smzbDom) {
            smzbDom.style.border = '1px solid #e8eaed';
          }
          // 4. 获取流式布局方框前边的 dom 节点
          let topimgDomArs = [];
          const domToImageArs = contentContainer.querySelectorAll('.no-break-to-imaged-top');
          for(let i = 0; i < domToImageArs.length; i++) {
            let domToImage = domToImageArs[i];
            const domCan = await html2canvas(domToImage, {
              scale: 2,
              width: domToImage.offsetWidth,
              height: domToImage.offsetHeight,
              useCORS: true,
              logging: false,
            });

            // toBlob() 是异步操作，返回一个 Promise
            const blob = await new Promise((resolve) => {
              // 'image/png' 是图片格式，也可以是 'image/jpeg' 等
              // 第三个参数是质量，仅对 jpeg 有效，范围 0-1
              domCan.toBlob(resolve, 'image/png', 1.0); 
            });

            // 3. 为 Blob 对象创建一个临时的 URL
            const imageUrl = URL.createObjectURL(blob);
            const img = new Image();
            img.src = imageUrl;
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.marginTop = '12px';
            topimgDomArs.push(img);
          }

          // 5. 获取流式布局方框后边的 dom 节点
          let bottomimgDomArs = [];
          const domBoImageArs = contentContainer.querySelectorAll('.no-break-to-imaged-bottom');
          for(let i = 0; i < domBoImageArs.length; i++) { 
            let domBoImage = domBoImageArs[i];
            // 修改呼吸详情样式，针对呼吸详情中的卡片，pdf到导出时添加边框
            const hxyczsDom = domBoImage.querySelectorAll('.comment-details-item-box');
            if(hxyczsDom&&hxyczsDom.length) {
              for(let j = 0; j < hxyczsDom.length; j++) {
                let jEle = hxyczsDom[j];
                jEle.style.width = '420px';
                // jEle.style.minHeight = '418px';
                jEle.style.border = '1px solid #e8eaed';
              }
            }

            // 获取指定的节点添加内边距，目前用于睡眠详情echars图表添加内边距
            const echarsEleDom = domBoImage.querySelectorAll('.no-break-card-echars-padd'); 
            echarsEleDom.forEach(el => { el.style.paddingTop = '10px'; });

            const domCan = await html2canvas(domBoImage, {
              scale: 2,
              width: domBoImage.offsetWidth,
              height: domBoImage.offsetHeight,
              useCORS: true,
              logging: false,
            });
            const blob = await new Promise((resolve) => {
              // 'image/png' 是图片格式，也可以是 'image/jpeg' 等
              // 第三个参数是质量，仅对 jpeg 有效，范围 0-1
              domCan.toBlob(resolve, 'image/png', 1.0); 
            });
            const imageUrl = URL.createObjectURL(blob);
            const img = new Image();
            img.src = imageUrl;
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.marginTop = '12px';
            bottomimgDomArs.push(img);
          }

          // 6. 克隆 DOM 容器（避免修改原 DOM）获取流式样式dom节点
          const clonedContainer = contentContainer.cloneNode(true);
          items = Array.from(clonedContainer.querySelectorAll('.no-break-card'));
          if(items&&items.length>0) {
            items[0].style.marginTop = '8px';
          }
          // 7. 获取流式盒子的元素并定义盒子宽度，将整个界面撑起来，使每个盒子的宽度都为界面的宽度，取消弹性盒子排列
          const elementsToResize1 = clonedContainer.querySelectorAll('.no-break-card, .comment-details-item');
          elementsToResize1.forEach(el => {
            // 设置所获取流式dom的宽度，单位为 px
            el.style.width = 'auto';
            el.style.marginTop = '12px';
          });

          // 获取流式盒子的元素并定义盒子宽度，将整个界面撑起来，使每个盒子的宽度都为界面的宽度，取消弹性盒子排列，并且调整边距
          const elementsToResize2 = clonedContainer.querySelectorAll('.comment-details-item-box');
          elementsToResize2.forEach(el => {
            // 设置所获取流式dom的宽度，单位为 px
            el.style.width = 'auto';
            el.style.padding = '0px 12px 12px 12px';
            el.style.marginTop = '12px';
          });
          
          // 8. 创建新 div
          const newDiv = document.createElement('div');
          newDiv.className = 'no-break-card';
          items.unshift(...topimgDomArs);
          items.push(...bottomimgDomArs);
        } else {
          const domToImageArs = contentContainer.querySelectorAll('.no-break-to-imaged-mul');
          for(let i = 0; i < domToImageArs.length; i++) {
            let domToImage = domToImageArs[i];
            if(domToImage.innerHTML == '<!---->'||domToImage.innerHTML == '') continue;

            if((domToImage.classList.contains('nowList')&&!domToImage.classList.contains('nowList_Ques'))||domToImage.classList.contains('healthy_measure_charts_card_item')) {
              domToImage.style.border = '1px solid #e8eaed';
            }
            
            if(domToImage.classList.contains('sleepReadWrap')) {
              domToImage.style.margin = 'auto';
            }

            const domCan = await html2canvas(domToImage, {
              scale: 2,
              width: domToImage.offsetWidth,
              height: domToImage.offsetHeight,
              useCORS: true,
              logging: false,
            });

            // toBlob() 是异步操作，返回一个 Promise
            const blob = await new Promise((resolve) => {
              // 'image/png' 是图片格式，也可以是 'image/jpeg' 等
              // 第三个参数是质量，仅对 jpeg 有效，范围 0-1
              domCan.toBlob(resolve, 'image/png', 1.0); 
            });
            const imageUrl = URL.createObjectURL(blob);
            const img = new Image();
            img.src = imageUrl;
            img.style.width = '100%';
            img.style.height = 'auto';
            img.style.marginTop = '12px';

            // 判断是否有break-to-imaged-dt-selitem-upper属性名，如果含有则和上一个dom节点合并为一个元素用于导出pdf,用于标题不分割
            if(domToImage.classList.contains('no-break-to-imaged-dt-selitem-upper')) {
              items[items.length-1].appendChild(img);
            } else {   
              const createNewDiv = document.createElement('div');
              createNewDiv.appendChild(img);
              items.push(createNewDiv);
            }
          }
        }

        // 9. 拼接pdf的名称并保存 PDF
        let fileName = bedName;
        if(date) {
          if(activeType == 1) {
            fileName = `${fileName}_${date}`
          } else if(activeType == 3) {
            fileName = `${fileName}_${getDateBefore(date, 6)}~${date}`
          } else if(activeType == 4) {
            fileName = `${fileName}_${getDateBefore(date, 29)}~${date}`
          }
        }
        
        let pageTotal = 1;
        let currentPageItems = [];
        let currentPageHeight = 0;
        for (const item of items) {
          // 10. 计算元素在 PDF 中的实际高度（需等待资源加载）
          const tempDiv = createTempDiv(item, pageWidthPx);
          await waitForResources(tempDiv); // 等待图片、背景图加载
          const itemHeight = tempDiv.offsetHeight;
          document.body.removeChild(tempDiv);

          // 11. 判断是否分页
          if (currentPageHeight + itemHeight > pageHeightPx) {
            await renderPage(doc, currentPageItems, pageWidthPx, pageHeightPx, pdfConfig.margin, fileName, pageTotal);
            pageTotal = pageTotal + 1;
            currentPageItems = [];
            currentPageHeight = 0;
            doc.addPage(); // 新增一页
          }

          currentPageItems.push(item);
          currentPageHeight += itemHeight;
        }

        // 12. 渲染最后一页
        if (currentPageItems.length > 0) {
          await renderPage(doc, currentPageItems, pageWidthPx, pageHeightPx, pdfConfig.margin, fileName, pageTotal);
        }

        // 13. 保存 PDF
        doc.save(`${fileName}.pdf`);
        resolve({
          code: 200
        })
      } catch (error) {
        reject({
          code: 500,
          message: error.message
        })
      }
    }, 500);
  });
}

function createTempDiv(element) {
  const tempDiv = document.createElement('div');
  tempDiv.style.width = `${852}px`;
  tempDiv.style.position = 'absolute';
  tempDiv.style.top = '-9999px';
  tempDiv.style.left = '-9999px';
  tempDiv.appendChild(element.cloneNode(true));
  document.body.appendChild(tempDiv);
  return tempDiv;
}

// 等待元素内所有资源（图片、背景图）加载完成
async function waitForResources(element) {
  // 等待 <img> 标签加载
  const imgPromises = Array.from(element.querySelectorAll('img')).map(img => {
    if (img.complete) return Promise.resolve();
    return new Promise(resolve => {
      img.onload = resolve;
      img.onerror = resolve; // 忽略加载失败
    });
  });

  // 等待背景图加载
  const bgImgPromises = Array.from(element.querySelectorAll('*')).map(el => {
    const style = window.getComputedStyle(el);
    const bgImg = style.backgroundImage;
    if (bgImg === 'none') return Promise.resolve();
    const img = new Image();
    img.src = bgImg.replace(/^url\(['"]?|['"]?\)$/g, '');
    if (img.complete) return Promise.resolve();
    return new Promise(resolve => {
      img.onload = resolve;
      img.onerror = resolve;
    });
  });

  await Promise.all([...imgPromises, ...bgImgPromises]);
}

// 渲染单页并添加到 PDF
async function renderPage(doc, items, pageWidthPx, pageHeightPx, marginMm, fileName, pageTotal) {
  const tempPage = document.createElement('div');
  tempPage.style.width = `${pageWidthPx}px`;
  tempPage.style.height = `${pageHeightPx}px`;
  tempPage.style.overflow = 'hidden';

  items.forEach(item => tempPage.appendChild(item));
  document.body.appendChild(tempPage);

  // 渲染为 canvas
  const canvas = await html2canvas(tempPage, {
    scale: 2,
    width: pageWidthPx,
    height: pageHeightPx,
    useCORS: true,
    logging: false,
  });

  document.body.removeChild(tempPage);

  // 转换为图片并添加到 PDF
  const imgData = canvas.toDataURL('image/jpeg', 0.95);
  doc.addImage(
    imgData,
    'JPEG',
    marginMm,
    marginMm,
    pageWidthPx / 3.78, // 转换为 mm
    pageHeightPx / 3.78 // 转换为 mm
  );

  drawHeader(doc, fileName, pageTotal);
}

function drawHeader(pdf, fileName, pageTotal) {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const headerYPosition = 8; // 页眉在页面上的 Y 坐标 (距离顶部 20pt)

  // 起始位置
  let startX = 0;
  // 距离两边的边距
  let pagePadding = 12;
  // 设置页眉字体样式
  pdf.setFontSize(10);
  // 设置字体样色
  pdf.setTextColor(38);
  // 绘制页眉
  pdf.text(fileName, startX + pagePadding, headerYPosition, { align: "left" });

  pdf.setFontSize(10);
  // pdf.setTextColor(232, 234, 237);
  pdf.text(`第 ${ pageTotal } 页`, pageWidth / 2, pageHeight - 3, { align: "center" });

  const offsetToTop = 5;
  // 设置线颜色
  pdf.setDrawColor(0, 0, 0, 0.06);
  // 设置线宽
  pdf.setLineWidth(0.1);
  pdf.line(
    startX + pagePadding,                      // 线的起点 x
    headerYPosition + offsetToTop,  // 线的起点 y
    startX + pageWidth - pagePadding,          // 线的终点 x
    headerYPosition + offsetToTop  // 线的终点 y
  );
}

/**
 * 计算给定日期前 n 天的日期
 * @param {string} dateStr - 给定的日期字符串，格式为 'YYYY-MM-DD'
 * @param {number} n - 要减去的天数
 * @returns {string} - 计算出的日期字符串，格式为 'YYYY-MM-DD'
 */
function getDateBefore(dateStr, n) {
  // 1. 将日期字符串转换为 Date 对象
  const date = new Date(dateStr);

  // 2. 检查日期是否有效
  if (isNaN(date.getTime())) {
    throw new Error("无效的日期格式，请使用 'YYYY-MM-DD' 格式");
  }

  // 3. 计算前 n 天的时间戳
  // getTime() 返回日期的毫秒数，一天的毫秒数是 86400000
  const timeStamp = date.getTime() - n * 24 * 60 * 60 * 1000;

  // 4. 根据时间戳创建新的 Date 对象
  const previousDate = new Date(timeStamp);

  // 5. 格式化日期为 'YYYY-MM-DD' 格式
  const year = previousDate.getFullYear();
  const month = String(previousDate.getMonth() + 1).padStart(2, '0');
  const day = String(previousDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}